import { render, staticRenderFns } from "./audit-changeCompany.vue?vue&type=template&id=21bbf873&scoped=true"
import script from "./audit-changeCompany.vue?vue&type=script&lang=js"
export * from "./audit-changeCompany.vue?vue&type=script&lang=js"
import style0 from "./audit-changeCompany.vue?vue&type=style&index=0&id=21bbf873&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21bbf873",
  null
  
)

export default component.exports